export enum PermissionValue {
  NotSet = 0,
  Allow = 1,
  Deny = 2
}
